import { PermissionType, PlatformCode } from '../type';
import { GetPermissionListParams } from './type';

const initState: {
  activeTab: PermissionType;
  platformCode: PlatformCode;
  selectedCateId: string;
  hasChildren: boolean;
  tableList: Array<Record<string, any>>;
  params: GetPermissionListParams;
  permissionList: Array<{
    permissionId: string;
    permissionName: string;
  }>;
} = {
  activeTab: PermissionType.ACTION,
  platformCode: 'FS',
  selectedCateId: '',
  hasChildren: true,
  tableList: [],
  params: {
    pageNo: 1,
    pageSize: 10,
  },
  permissionList: [],
};

const model = {
  state: initState,
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { AuthPoint }, getState }) => ({
    setActiveTab(activeTab) {
      AuthPoint.setState({ activeTab });
    },
    setPlatformCode(platformCode) {
      AuthPoint.setState({ platformCode });
    },
    setSelectedCateId(selectedCateId) {
      AuthPoint.setState({ selectedCateId });
    },
    setHasChildren(hasChildren) {
      AuthPoint.setState({ hasChildren });
    },
    setTableList(tableList) {
      AuthPoint.setState({ tableList });
    },
    setTotal(total) {
      AuthPoint.setState({ total });
    },
    setParams(params) {
      AuthPoint.setState({ params });
    },
    setPermissionList(permissionList) {
      AuthPoint.setState({ permissionList });
    },
    init() {
      AuthPoint.setState({ ...initState });
    },
  }),
};

export default model;
